/*
 * Dusk Oak, round nineteen: precision pass.
 * UX guideline 63 (mobile keyboards): quantity fields open the number
 * pad on phones. Covers the product page and the cart drawer, which
 * re-renders its inputs, so new ones are caught as they appear.
 */
(function () {
  'use strict';

  var SEL = 'input[name="quantity"], input[name="updates[]"]';

  function tag(root) {
    if (!root || !root.querySelectorAll) return;
    var list = root.matches && root.matches(SEL) ? [root] : root.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('inputmode') !== 'numeric') {
        list[i].setAttribute('inputmode', 'numeric');
      }
    }
  }

  function init() {
    tag(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) tag(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
